import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import { PropsWithChildren, useEffect } from "react";
import { logger } from "@caju-beneficios/monitoring";

const featureFlagClient = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.REACT_APP_GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: true,
  plugins: [autoAttributesPlugin()],
  trackingCallback: (experiment: any, result: any) => {
    logger.info({
      message: "Experiment Viewed",
      context: {
        experimentId: experiment.key,
        variationId: result.key,
      },
    });
  },
});

export function FeatureFlagProvider(props: PropsWithChildren) {
  useEffect(() => {
    async function init() {
      try {
        const response = await featureFlagClient.init();

        let deviceId = localStorage.getItem("gb-deviceId");

        if (!deviceId) {
          deviceId = crypto.randomUUID();
          localStorage.setItem("gb-deviceId", deviceId);
        }

        featureFlagClient.setAttributes({
          deviceId,
        });

        if (!response.success) throw response.error;
      } catch (error) {
        logger.error({
          message: "FeatureFlagProvider initialization failed",
          error: error as Error,
          context: {
            application: "quero-caju",
            component: "FeatureFlagProvider",
            service: "growthbook",
          },
        });
      }
    }

    init();
  }, []);

  return (
    <GrowthBookProvider growthbook={featureFlagClient}>
      {props.children}
    </GrowthBookProvider>
  );
}
